import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f8fafc",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          p: 4,
          maxWidth: 560,
          width: "100%",
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            width: 180,
            height: 180,
            borderRadius: "50%",
            bgcolor: "#e3f2fd",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 4,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 100, color: "#1976d2" }} />
        </Box>

        {/* 404 */}
        <Typography
          sx={{
            fontSize: { xs: "48px", md: "56px" },
            fontWeight: 700,
            color: "#1976d2",
            mb: 1,
          }}
        >
          404!
        </Typography>

        {/* Title */}
        <Typography
          sx={{
            fontSize: { xs: "22px", md: "26px" },
            fontWeight: 600,
            mb: 2,
            color: "text.primary",
            opacity: 0.75,
          }}
        >
          Page Not Found
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: { xs: "15px", md: "16px" },
            color: "text.secondary",
            lineHeight: 1.6,
            maxWidth: 480,
            mx: "auto",
          }}
        >
          The page you are looking for might have been moved, removed, renamed,
          or might never exist.
        </Typography>
      </Box>
    </Box>
  );
}
